import React from 'react';

// Bottoni social (Google/Microsoft) per l'accettazione invito — stessi SVG e stile
// dei bottoni di RegisterPage/Login. Estratti in componente dedicato per tenere
// InviteAcceptForm.tsx sotto le ~250 righe.
interface InviteSocialButtonsProps {
  showGoogle: boolean;
  showMicrosoft: boolean;
  oauthLoading: 'google' | 'azure' | null;
  disabled: boolean;
  onSelect: (provider: 'google' | 'azure') => void;
}

export function InviteSocialButtons({
  showGoogle,
  showMicrosoft,
  oauthLoading,
  disabled,
  onSelect,
}: InviteSocialButtonsProps) {
  if (!showGoogle && !showMicrosoft) return null;

  return (
    <div>
      <div className="relative my-1">
        <div className="absolute inset-0 flex items-center">
          <div className="w-full border-t border-[rgba(55,53,47,0.09)]" />
        </div>
        <div className="relative flex justify-center text-sm">
          <span className="px-3 text-[#787774] bg-white">oppure</span>
        </div>
      </div>

      {showGoogle && (
        <button
          type="button"
          disabled={!!oauthLoading || disabled}
          onClick={() => onSelect('google')}
          className="mt-3 w-full flex items-center justify-center gap-3 py-3 px-4 rounded-lg border border-[rgba(55,53,47,0.16)] bg-white hover:bg-[rgba(55,53,47,0.03)] text-[#37352F] text-sm font-medium transition-all duration-200 disabled:opacity-50"
        >
          {oauthLoading === 'google' ? (
            <div className="w-5 h-5 border-2 border-[rgba(55,53,47,0.2)] border-t-[#37352F] rounded-full animate-spin" />
          ) : (
            <svg className="w-5 h-5" viewBox="0 0 24 24">
              <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1z"/>
              <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
              <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
              <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
            </svg>
          )}
          Continua con Google
        </button>
      )}

      {showMicrosoft && (
        <button
          type="button"
          disabled={!!oauthLoading || disabled}
          onClick={() => onSelect('azure')}
          className="mt-3 w-full flex items-center justify-center gap-3 py-3 px-4 rounded-lg border border-[rgba(55,53,47,0.16)] bg-white hover:bg-[rgba(55,53,47,0.03)] text-[#37352F] text-sm font-medium transition-all duration-200 disabled:opacity-50"
        >
          {oauthLoading === 'azure' ? (
            <div className="w-5 h-5 border-2 border-[rgba(55,53,47,0.2)] border-t-[#37352F] rounded-full animate-spin" />
          ) : (
            <svg className="w-5 h-5" viewBox="0 0 24 24">
              <path fill="#F25022" d="M1 1h10v10H1z"/>
              <path fill="#00A4EF" d="M1 13h10v10H1z"/>
              <path fill="#7FBA00" d="M13 1h10v10H13z"/>
              <path fill="#FFB900" d="M13 13h10v10H13z"/>
            </svg>
          )}
          Continua con Microsoft
        </button>
      )}
    </div>
  );
}

export default InviteSocialButtons;
